export default __webpack_public_path__ + "static/media/341-icon.43e30942.svg";